import React, { FC } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { LabClient } from 'models/client-directory';

type SupplierSettingsHeaderProps = {
    labClient: LabClient;
};
const SupplierSettingsHeader: FC<SupplierSettingsHeaderProps> = ({ labClient }: SupplierSettingsHeaderProps) => {
    return (
        <Box p={2}>
            <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography variant="h1">{labClient?.clientContent?.name || labClient.lab?.name}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                    <Box mr={1}>
                        <Typography color="gray" variant="caption">
                            {labClient?.lab?._id}
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Divider />
        </Box>
    );
};

export default SupplierSettingsHeader;
